export interface ParagraphSplitResult {
  paragraphs: string[];
  shouldSplit: boolean;
}

const PARAGRAPH_BREAK = /(?:\r?\n\s*){2,}/;
const PARAGRAPH_SEPARATOR = '\n\n';
const LIST_MARKER = /^(?:[-*+]|\d{1,9}[.)])\s/;

const mergeListsIntoPrecedingParagraph = (paragraphs: string[]): string[] =>
  paragraphs.reduce<string[]>((merged, paragraph) => {
    if (merged.length > 0 && LIST_MARKER.test(paragraph)) {
      return [
        ...merged.slice(0, -1),
        merged[merged.length - 1] + PARAGRAPH_SEPARATOR + paragraph
      ];
    }
    return [...merged, paragraph];
  }, []);

export function splitIntoParagraphs(content: string): ParagraphSplitResult {
  if (!content || typeof content !== 'string') {
    return { paragraphs: [], shouldSplit: false };
  }

  const rawParagraphs = content
    .split(PARAGRAPH_BREAK)
    .map((paragraph) => paragraph.trim())
    .filter((paragraph) => paragraph.length > 0);

  const paragraphs = mergeListsIntoPrecedingParagraph(rawParagraphs);

  if (paragraphs.length <= 1) {
    return { paragraphs: [content], shouldSplit: false };
  }

  return {
    paragraphs,
    shouldSplit: true
  };
}
